import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RelacaoProvider {

      apiRoot: string = 'http://192.99.185.73:8070';
   apiIntegra: string = 'http://integra02.connectparts.com.br:8032';
   liderEmail: any;
  userDetails: any;

  constructor(public http: HttpClient) {
    console.log('Hello RelacaoProvider Provider');
  }

  getUsuario(){

    const header = new HttpHeaders({ 'Content-Type':  'application/json',
                                     'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiIntegra + '/ControleAcesso/Usuario/Listar'
                        , { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  getLideres(){

    const header = new HttpHeaders({ 'Content-Type':  'application/json',
                                     'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    const data = JSON.parse(localStorage.getItem('userLogin'));
    if(data){

        this.userDetails = data;
        this.liderEmail = this.userDetails.user_mail;
    }

    return this.http
      .get(this.apiRoot + '/LideresXUsuarios/Listar?parametros.emailLider='
                        + this.liderEmail, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);

  }

  postUsuarioxLideres(email: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json',
                                     'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    const data = JSON.parse(localStorage.getItem('userLogin'));
    if(data){

        this.userDetails = data;
        this.liderEmail = this.userDetails.user_mail;
    }

    return this.http
      .post(this.apiRoot + '/LideresXUsuarios/Adicionar?'
                         + 'parametros.emailAnalista=' + email
                         + '&parametros.emailLider=' + this.liderEmail,
                        { }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);

  }

  removeUsuarioxLideres(id: number){

    const header = new HttpHeaders({ 'Content-Type':  'application/json',
                                     'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    const data = JSON.parse(localStorage.getItem('userLogin'));
    if(data){

        this.userDetails = data;
        this.liderEmail = this.userDetails.user_mail;
    }

    return this.http
      .post(this.apiRoot + '/LideresXUsuarios/Remover/'
                         + id,

                        { }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);

  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};

    if (error.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;

        console.log(error.error);

    } else {

        errorMessage = { status: error.status, message: error.error.Message };

        console.log(errorMessage);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/relacao/relacao.ts